<template>
  <div>
    <v-form ref="refMain">
      <v-container fluid>
        <v-row fluid>
          <v-col cols="12" sm="2" md="2" lg="2" class="pa-1">
            <v-autocomplete v-model="dOrgId" label="* Unidad de Negocio"
                            :items="dOrg"  item-value="IdCentProd" item-text="Descripcion"
                            :disabled="dIsUpdating" filled prepend-inner-icon="bookmark" :rules="[v => !!v || 'El campo es requerido']">
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="2" md="2" lg="2" class="pa-1">
            <v-autocomplete v-model="dIdServicio" label="* Carrera Profesional"
                            :items="dPriServicios"  item-value="IdServicio" item-text="Descripcion"
                            :disabled="dIsUpdating" filled prepend-inner-icon="bookmark" :rules="[v => !!v || 'El campo es requerido']">
            </v-autocomplete>
          </v-col>
          <v-col cols="2" sm="2" md="2" lg="2" class="pa-1">
            <v-menu
                v-model="dFInicioMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="dFInicio"
                    label="Fecha Inicio Seccion Desde"
                    prepend-inner-icon="event_note"
                    readonly
                    filled
                    v-bind="attrs"
                    v-on="on"
                    :rules="[v => !!v || 'El campo es requerido']"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="dFInicio"
                  @input="dFInicioMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="2" sm="2" md="2" lg="2" class="pa-1">
            <v-menu
                v-model="dFFinMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                    v-model="dFFin"
                    label="Fecha Inicio Seccion Hasta"
                    prepend-inner-icon="event_note"
                    readonly
                    filled
                    v-bind="attrs"
                    v-on="on"
                    :rules="[v => !!v || 'El campo es requerido']"
                ></v-text-field>
              </template>
              <v-date-picker
                  v-model="dFFin"
                  @input="dFFinMenu = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="2" sm="2" md="2" lg="2" class="pa-1">
            <v-select v-model="dLmsId" label="Lms"
                      :items="dLms"
                      filled prepend-inner-icon="school"></v-select>
          </v-col>
          <v-col cols="2" sm="2" md="2" lg="2" class="pa-1">
            <v-select v-model="dEnviado" label="Estado"
                      :items="[{text: 'PENDIENTE', value: '0,2,3,4,5'},
                                    {text: 'FINALIZADO', value: '1'}]"
                      filled prepend-inner-icon="invert_colors"></v-select>
          </v-col>
          <v-col cols="1" sm="1" md="1" lg="1" class="pa-1">
            <v-btn @click.prevent="fuSearch" :loading="dTable.loading" color="blue-grey" dark x-large><v-icon>search</v-icon> Buscar</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-card>
      <v-card-title>
        <v-text-field
            v-model="dTable.search"
            prepend-icon="search"
            label="Filtrar por ..."
            single-line
            dense
            hide-details
            clearable
        ></v-text-field>
      </v-card-title>
      <v-data-table
          v-model="dTable.selected"
          :headers="dTable.headers"
          :items="dCargaDocente"
          :loading="dTable.loading"
          :search="dTable.search"
          :custom-filter="customFilter"
          item-key="IdCargaDocente"
          show-select
          class="elevation-1">
        <template v-slot:no-data><v-alert :value="true" color="warning" icon="warning">No hay registros para mostrar.</v-alert></template>
        <template v-slot:no-results><v-alert :value="true" color="warning" icon="warning">No se encontro ningun registro con su busqueda "{{ dTable.search }}".</v-alert></template>
        <template v-slot:[`item.Personal`]="{ item }">
          <span>{{item.Personal}}</span>
        </template>
        <template v-slot:[`item.Seccion`]="{ item }">
          <span>{{item.Nivel}} {{item.Seccion}}</span>
        </template>
        <template v-slot:[`item.Descripcion`]="{ item }">
          <span>{{item.Descripcion }}</span>
        </template>
        <template v-slot:[`item.Enviado`]="{ item }">
          <span>{{item.Enviado | fiEstado}}</span>
        </template>
      </v-data-table>
    </v-card>
    <v-divider></v-divider>
    <div class="pa-3 blue-grey darken-2">
      <v-btn @click.prevent="fuSave" :loading="dIsUpdating" color="primary"><v-icon left>autorenew</v-icon> Reiniciar Proceso</v-btn>
    </div>
    <v-snackbar v-model="dSnackbar" color="red">Revise el formulario, existe datos erróneos.
      <v-btn text @click="dSnackbar = false"> Cerrar </v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import moment from 'moment';
import gql from 'graphql-tag';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
export default {
  name: 'MatCargaDocente',
  data: () => ({
    dEnviado: '0,2,3,4,5',
    dFInicio: moment().subtract(30,'d').format('YYYY-MM-DD'),
    dFInicioMenu: false,
    dFFin: moment().format('YYYY-MM-DD'),
    dFFinMenu: false,
    dIsUpdating: false,
    dCargaDocente: [],
    dSnackbar: false,
    dLmsId: '',
    dIdSeccion: '',
    dIdServicio: '',
    dOrgId: '',
    dPeriodo: '',
    dPriServicios: [],
    dOrg: [],
    dLms: [
      {value: 1, text: '1 - Teams' },
      {value: 2, text: '2 - Moodle' },
      {value: 3, text: '3 - Canvas - Instructure' },
      {value: 4, text: '4 - Canvas - Khipu' },
      {value: '', text: 'Otro' },
    ],
    dTable: {
      headers: [
        {value: 'IdCargaDocente', text: 'IdCargaDocente', align: ' d-none'},
        {value: 'Seccion', text: 'Seccion'},
        {value: 'Personal', text: 'Docente'},
        {value: 'Descripcion', text: 'Curso'},
        {value: 'Enviado', text: 'Estado'},
      ],
      loading: false,
      search: null,
      selected: []
    }
  }),
  mounted(){
    this.Usuario = JSON.parse(localStorage.getItem('ssUser'))
    this.fuLoadOrg(this.Usuario)
  },
  watch: {
    'dOrgId' (val) {
      this.fuLoad(val);
    }
  },
  methods: {
    async fuLoad(Unidad){
      const response = await this.$apollo.query({
        query: gql`query priservicioByIdCentroProdByActivo($IdCentroProd: Int!){
                    priservicioByIdCentroProdByActivo (IdCentroProd: $IdCentroProd, Activo: 1){
                      IdServicio
                      Descripcion
                    }
                }`,
        variables: {
          IdCentroProd: Unidad
        }
      })
      this.dPriServicios = response.data.priservicioByIdCentroProdByActivo;
    },
    async fuLoadOrg(User){
      const response = await this.$apollo.query({
        query: gql`query centProdLmsUsuario($Usuario: String!){
                    centProdLmsUsuario(Usuario: $Usuario){
                      IdCentProd
                      Descripcion
                      Usuario
                    }
                }`,
        variables: {
          Usuario: User.Usuario
        }
      })
      this.dOrg = response.data.centProdLmsUsuario;
    },
    customFilter(value, search, item) {
      search = search.toString().toLowerCase();
      if(item.pripersonal) {
        const val = item.pripersonal.Personal.toString().toLowerCase();
        if(val.indexOf(search) !== -1) return true;
      }
      if(item.matseccion) {
        const val = item.matseccion.matperiodo.priservicio.SiglaCodigoAlumno.toString().toLowerCase() + item.matseccion.matperiodo.Nivel + item.matseccion.Seccion.toString().toLowerCase();
        if(val.indexOf(search) !== -1) return true;
      }
      if(item.matcursoscurricula) {
        const val = item.matcursoscurricula.matcurso.Descripcion.toString().toLowerCase();
        if(val.indexOf(search) !== -1) return true;
      }
      return false;
    },
    fuSearch(){
      if(!this.$refs.refMain.validate()){
        this.dSnackbar = true;
      } else {
        this.fuCargaDocenteByPublicadoByEnviadoByFechas();
      }
    },
    fuSave() {
      if(this.dTable.selected.length===0){
        Swal.fire('Información', 'Debe seleccionar un elemento', 'info')
      } else {
        this.fuCargaDocenteEnviadoByIdCargaDocenteUpdate();
      }
    },
    async fuCargaDocenteByPublicadoByEnviadoByFechas() {
      this.dTable.selected = [];
      this.dTable.loading = true;
      let vFInicio =this.dFInicio.substring(0,10).split("-").join("");
      let vFFin =this.dFFin.substring(0,10).split("-").join("");
      try {
        const response = await this.$apollo.query({
          query: gql`query matdocentesLmsCentProd($IdCentroProd: Int!, $FechaInicio: String!, $FechaFin: String!, $Lms: String, $IdServicio: String!, $Enviado: String!) {
            matdocentesLmsCentProd(IdCentroProd: $IdCentroProd, FechaInicio: $FechaInicio, FechaFin: $FechaFin, Lms: $Lms, IdServicio: $IdServicio, Enviado: $Enviado) {
              IdCargaDocente
              Enviado
              Seccion
              Nivel
              Personal
              Descripcion
            }
          }`,
          variables: {
            IdCentroProd: this.dOrgId,
            IdServicio: this.dIdServicio,
            Enviado: this.dEnviado,
            FechaInicio: vFInicio,
            FechaFin: vFFin,
            Lms: this.dLmsId,
          },
          fetchPolicy: 'no-cache'
        });
        this.dCargaDocente = [];
        this.dCargaDocente = response.data.matdocentesLmsCentProd;
        console.log(response)
      } catch (error) {
        console.log(error);
        Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
      } finally {
        this.dTable.loading = false
      }
    },
    async fuCargaDocenteEnviadoByIdCargaDocenteUpdate() {
      let vIdCargaDocente = this.dTable.selected.map(x=>x.IdCargaDocente);
      vIdCargaDocente = vIdCargaDocente.join(',');
      this.dIsUpdating = true;
      try {
        const response = await this.$apollo.mutate({
          mutation: gql`mutation update($IdCentroProd: Int!, $IdCargaDocente: String!){
            matdocenteupdateLmsCentProd(IdCentroProd: $IdCentroProd, IdCargaDocente:$IdCargaDocente){
              success
              message
              data
            }
          }`,
          variables: {
            IdCentroProd: this.dOrgId,
            IdCargaDocente : vIdCargaDocente
          }
        });
        if(response.data.matdocenteupdateLmsCentProd.success==0){
          Swal.fire('¡ ERROR !', 'No se modifico la(s) carga(s).', 'error');
        } else {
          Swal.fire('CORRECTO', 'Se modifico la(s) carga(s).', 'success');
          this.fuCargaDocenteByPublicadoByEnviadoByFechas()
          this.dCargaDocente = [];
        }
      } catch (error) {
        console.log(error);
        Swal.fire('¡ ERROR !', 'Error de conexión.', 'error');
      } finally {
        this.dIsUpdating = false;
      }
    }
  },
  filters: {
    fiEstado: function (value) {
      let vMessage=''
      switch (value) {
        case 0:
          vMessage = value + ' - En espera de proceso';
          break;
        case 1:
          vMessage = value + ' - Proceso completado';
          break;
        case 2:
          vMessage = value + ' - En espera de paso 02';
          break;
        case 3:
          vMessage = value + ' - En espera de paso 03';
          break;
        default:
          vMessage=value+' - Otro Error';
          break;
      }
      return vMessage;
    }
  }
}
</script>

<style>

</style>